import { Component, OnInit, inject, Output, Input, EventEmitter } from "@angular/core";
import { PaginationModel } from "src/app/shared/models/common";
import { AppState } from "src/app/shared/redux/store";
import { Order } from "src/app/shared/models/order.model";
import { ServiceMetaData } from "src/app/shared/models/service-meta.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { RealtimeService } from "src/app/shared/services/realtime.service";
import { Popover, PopoverModule } from "primeng/popover";
import { Store } from "@ngrx/store";
import { currentOrder } from "src/app/shared/ngrx/ngrx-selectors";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { FOCUS_ORDER_CHAT_TAB } from "src/app/shared/ngrx/ngrx-actions";
import { TranslateModule } from "@ngx-translate/core";
import { OrderStageIconComponent } from "src/app/shared/components/order-stage-icon/order-stage-icon.component";
import { OrderUrgencyIconComponent } from "src/app/shared/components/order-urgency-icon/order-urgency-icon.component";
import { TableComponent } from "src/app/shared/components/ui/table/table.component";
import { CommonModule } from "@angular/common";
import { CheckboxWrapComponent } from "src/app/shared/components/ui/checkbox-wrap.component";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "inbox-list",
  templateUrl: "./inbox-list.component.html",
  styleUrls: ["./inbox-list.component.scss"],
  imports: [
    PopoverModule,
    TranslateModule,
    OrderStageIconComponent,
    OrderUrgencyIconComponent,
    TableComponent,
    CommonModule,
    CheckboxWrapComponent,
    FormsModule,
  ],
  standalone: true,
})
export class InboxListComponent implements OnInit {
  @Output() onPagination = new EventEmitter<PaginationModel>();
  @Output() onRowSelected = new EventEmitter<Order>();
  @Output() onGoToOrder = new EventEmitter<Order>();
  @Output() onGoToChat = new EventEmitter<Order>();
  @Output() onMarkFavorite = new EventEmitter<Order>();
  @Output() onDownloadSelectedRX = new EventEmitter();
  @Output() onDownloadRXOnPage = new EventEmitter();

  @Input() displayOrders: Order[];
  @Input() totalRecords: number;
  @Input() numberOfRows: number;
  @Input() metaData: ServiceMetaData;

  displayColumnsList: string[];
  displayUrgency: boolean = false;
  displayTasks: boolean = false;
  displayInHouse: boolean = false;
  displayRx: boolean = false;
  plantUserSw: boolean;
  labUserSw: boolean;
  clinicUserSw: boolean;
  toggleCheckAll: boolean;
  displayDownloadRxPanel: boolean;
  destroy$ = new Subject();

  get selectedOrder(): Order {
    return this.store.selectSignal(currentOrder)();
  }

  get downloadSelectedRXEnabled(): boolean {
    if (!this.displayOrders) return false;
    return this.displayOrders.filter((o) => o.checkedSw).length > 0;
  }

  get downloadRXOnPageEnabled(): boolean {
    if (!this.displayOrders) return false;
    return (
      this.displayOrders.filter((o) => o.rxToDownload.length > 0).length > 0
    );
  }

  get paginatorFirst(): number {
    if (!this.metaData?.fromRecord) return 0;
    // first is 0-indexed, fromRecord is 1-indexed
    return this.metaData.fromRecord - 1;
  }

  readonly realtime = inject(RealtimeService);

  constructor(private readonly store: Store, private authService: AuthService) {
    this.plantUserSw = this.authService.currentUser.org == "PLANT";
    this.labUserSw = this.authService.currentUser.org == "LAB";
    this.clinicUserSw = this.authService.currentUser.org == "CLINIC";
    this.displayTasks =
      this.authService.currentUser.authDetails.getBooleanValue(
        "ORDERS.CHAT_TASKS_SW"
      );

    if (this.labUserSw) {
      this.displayUrgency = true;
      this.displayInHouse = true;
      this.displayColumnsList = [
        "displayId",
        "clinicDescr",
        "doctorFullName",
        "patientFullName",
        "orderDateFormatted",
      ];
    } else if (this.plantUserSw) {
      this.displayUrgency = true;
      this.displayColumnsList = [
        "displayId",
        "clinicId",
        "doctorId",
        "orderDateFormatted",
      ];
    } else if (this.clinicUserSw && this.authService.currentUser.isMultiClinicUser) {
      this.displayColumnsList = [
        "displayId",
        "clinicDescr",
        "patientFullName",
        "orderDateFormatted",
      ];
    } else {
    this.displayColumnsList = [
      "displayId",
      "doctorFullName",
      "patientFullName",
      "orderDateFormatted",
    ];
  }
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this.destroy$.next(1);
  }

  onUpdate($event) {
    this.onPagination.emit($event);
  }

  onRowSelect(order: Order) {
    this.store.dispatch(
      FOCUS_ORDER_CHAT_TAB({
        focusOrderChatTab: false,
      })
    );
    this.onRowSelected.emit(order);
  }

  goToChat(order: Order, event: MouseEvent) {
    event.stopPropagation();
    this.onGoToChat.emit(order);
  }

  markFavorite(order: Order, event: MouseEvent) {
    event.stopPropagation();
    this.onMarkFavorite.emit(order);
  }

  onToggleAll() {
    this.displayOrders.forEach((o) => {
      if (o.hasRx) o.checkedSw = this.toggleCheckAll;
    });
  }

  downloadSelectedRX(overlaypanel: Popover) {
    this.displayDownloadRxPanel = false;
    overlaypanel.hide();
    this.onDownloadSelectedRX.emit();
  }

  downloadRXOnPage(overlaypanel: Popover) {
    this.displayDownloadRxPanel = false;
    overlaypanel.hide();
    this.onDownloadRXOnPage.emit();
  }
}
